import { Component, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FikoDinamikKesit, FikoDinamikKesitAyarlar } from '../FikoDinamikKesit';

@Component({
    selector: 'fikoyt-kesit-ayarlar',
    standalone: true,
    imports: [CommonModule, FormsModule],
    templateUrl: './kesit-ayarlar.component.html',
    styleUrls: ['./kesit-ayarlar.component.scss']
})
export class KesitAyarlarComponent {
    @Input() dinamikKesit!: FikoDinamikKesit;
    @Output() ayarlarDegisti = new EventEmitter<FikoDinamikKesitAyarlar>();

    kesitAyarlar!: FikoDinamikKesitAyarlar;

    // Hex renk değerleri
    dolguRenkHex: string = '#ff6b6b';
    cizgiRenkHex: string = '#ff0000';

    // Sekmeler
    sekmeler = {
        kesitModu: true,
        gorselAyarlar: false,
        duzlemAyarlari: false
    };

    constructor(public CD: ChangeDetectorRef) {}

    ngOnInit() {
        this.kesitAyarlar = { ...this.dinamikKesit.ayarlar };
        this.dolguRenkHex = '#' + this.kesitAyarlar.kesitDolguRenk.toString(16).padStart(6, '0');
        this.cizgiRenkHex = '#' + this.kesitAyarlar.kesitCizgiRenk.toString(16).padStart(6, '0');
    }

    toggleSekme(sekme: string) {
        this.sekmeler[sekme] = !this.sekmeler[sekme];
    }

    // Kesit modu
    kesitModuDegisti() {
        this.dinamikKesit.ayarlariGuncelle({ kesitModu: this.kesitAyarlar.kesitModu });
        this.kaydetAyarlar();
    }

    // Görünürlük toggles
    gosterKesitDuzlemiDegisti() {
        this.dinamikKesit.ayarlariGuncelle({ gosterKesitDuzlemi: this.kesitAyarlar.gosterKesitDuzlemi });
        this.kaydetAyarlar();
    }

    gosterKesitDolguDegisti() {
        this.dinamikKesit.ayarlariGuncelle({ gosterKesitDolgu: this.kesitAyarlar.gosterKesitDolgu });
        this.kaydetAyarlar();
    }

    gosterKesitCizgiDegisti() {
        this.dinamikKesit.ayarlariGuncelle({ gosterKesitCizgi: this.kesitAyarlar.gosterKesitCizgi });
        this.kaydetAyarlar();
    }

    // Renk değişiklikleri
    dolguRenkDegisti() {
        const renk = parseInt(this.dolguRenkHex.replace('#', ''), 16);
        this.kesitAyarlar.kesitDolguRenk = renk;
        this.dinamikKesit.ayarlariGuncelle({ kesitDolguRenk: renk });
        this.kaydetAyarlar();
    }

    cizgiRenkDegisti() {
        const renk = parseInt(this.cizgiRenkHex.replace('#', ''), 16);
        this.kesitAyarlar.kesitCizgiRenk = renk;
        this.dinamikKesit.ayarlariGuncelle({ kesitCizgiRenk: renk });
        this.kaydetAyarlar();
    }

    // Opacity değişiklikleri
    dolguOpacityDegisti() {
        this.dinamikKesit.ayarlariGuncelle({ kesitDolguOpacity: this.kesitAyarlar.kesitDolguOpacity });
        this.kaydetAyarlar();
    }

    cizgiKalinlikDegisti() {
        this.dinamikKesit.ayarlariGuncelle({ kesitCizgiKalinlik: this.kesitAyarlar.kesitCizgiKalinlik });
        this.kaydetAyarlar();
    }

    duzlemBoyutuDegisti() {
        this.dinamikKesit.ayarlariGuncelle({ duzlemBoyutu: this.kesitAyarlar.duzlemBoyutu });
        this.kaydetAyarlar();
    }

    duzlemOpacityDegisti() {
        this.dinamikKesit.ayarlariGuncelle({ duzlemOpacity: this.kesitAyarlar.duzlemOpacity });
        this.kaydetAyarlar();
    }

    // Ayarları kaydet
    kaydetAyarlar() {
        this.ayarlarDegisti.emit(this.kesitAyarlar);
    }

    // Ayarları sıfırla
    resetAyarlar() {
        this.kesitAyarlar = {
            kesitModu: 'smooth',
            kesitDolguRenk: 0xff6b6b,
            kesitDolguOpacity: 0.8,
            kesitCizgiRenk: 0xff0000,
            kesitCizgiKalinlik: 2,
            gosterKesitDuzlemi: true,
            gosterKesitDolgu: true,
            gosterKesitCizgi: true,
            duzlemBoyutu: 500,
            duzlemOpacity: 0.15
        };
        this.dolguRenkHex = '#ff6b6b';
        this.cizgiRenkHex = '#ff0000';
        this.dinamikKesit.ayarlariGuncelle(this.kesitAyarlar);
        this.kaydetAyarlar();
    }
}
